import ReactPlayer from 'react-player';

const VideoSection = ({ videoUrl }) => {
  return (
    videoUrl ? (
      <div className="my-3">
        <ReactPlayer
          url={videoUrl}
          width="100%"
          height="350px"
          controls
        />
      </div>
    ) : null
  );
};

export default VideoSection;